import QRCode from "react-qr-code";
import styles from "./main-page.module.css";
import { memo, useContext } from "react";
import { PageContenProps } from "./MainPage";
import { LocalizationContext } from "../context/LocalizationContext";

export const MobileContent = memo((props: PageContenProps) => {
  const { currentURL, inlineStyle } = props;
  const localizationContext = useContext(LocalizationContext);

  const noAppUrl = new URL(currentURL);
  noAppUrl.searchParams.append('noapp', 'true');

  return (
    <>
      <span className={styles.qrTitle} style={inlineStyle.qrTitle}>
        {localizationContext?.localization?.modaldescription}
      </span>
      <div className={styles.qrWrapper}>
        <QRCode
          size={100}
          value={currentURL}
          viewBox={`0 0 256 256`}
          className={styles.qr}
          fgColor={inlineStyle.qr.fgColor}
          bgColor={inlineStyle.qr.bgColor}
        />
      </div>

      <a
        href={noAppUrl.toString()}
        target="_blank"
        className={styles.mobileLinkButton}
        rel="noreferrer"
        style={inlineStyle.mobileLinkButton}
      >
        <span>{localizationContext?.localization?.modalproceedbutton}</span>
      </a>
    </>
  );
});
